import { environment } from "src/environments/environment";
import storageX from "../storageCore/storageX";
import { STORAGE_KEY_ACCESS_TOKEN_WSO2 } from "../storageCore/constStorageKeys";
import getBrowserFingerprint from "get-browser-fingerprint";
import { ensureDeviceUuid } from "./device-uuid";

type GatewayTokenResponse = {
  access_token?: string;
};

let refreshPromise: Promise<string> | null = null;

export async function refreshWso2TokenOnce(): Promise<string> {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const clientId = environment.apisConfig.gateway.clientId;
    const clientSecret = environment.apisConfig.gateway.clientSecret;
    const baseOauthUrl = environment.apisConfig.gateway.baseOauthUrl;
    const fingerprint = getBrowserFingerprint();
    const uuid = ensureDeviceUuid();

    const response = await fetch(baseOauthUrl.concat("/token"), {
      method: "POST",
      headers: {
        Authorization: "Basic " + btoa(clientId + ":" + clientSecret),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "client_credentials",
        scope: "devices_" + fingerprint + "-" + uuid,
      }),
    });

    if (!response.ok) {
      throw new Error("Falha ao renovar token WSO2");
    }

    const payload = (await response.json()) as GatewayTokenResponse;
    const accessToken = payload?.access_token || "";
    if (!accessToken) {
      throw new Error("Token WSO2 vazio na renovacao");
    }

    storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).set(accessToken);
    return accessToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}
